import { http } from '../request'
import type {
  NotificationItem,
  NotificationListRequest,
  NotificationListResponse,
  NotificationUnreadCountResponse,
  MarkReadResponse,
  MarkAllReadResponse
} from '../types/notifications'

/**
 * 通知模块 API
 * 后端基础路径：/api/services/notifications/
 */
export const notificationsApi = {
  // 获取通知列表
  list(params?: NotificationListRequest): Promise<NotificationListResponse> {
    return http.list<NotificationItem>('/api/services/notifications/', params)
  },

  get(id: number): Promise<NotificationItem> {
    return http.get<NotificationItem>(`/api/services/notifications/${id}/`)
  },

  // 获取未读通知列表（分页）
  listUnread(): Promise<NotificationListResponse> {
    return http.list<NotificationItem>('/api/services/notifications/unread/')
  },

  // 获取未读数量
  getUnreadCount(): Promise<NotificationUnreadCountResponse> {
    return http.get<NotificationUnreadCountResponse>('/api/services/notifications/unread-count/')
  },

  // 标记单条通知为已读
  markRead(id: number): Promise<MarkReadResponse> {
    return http.post<MarkReadResponse>(`/api/services/notifications/${id}/mark-read/`)
  },

  // 标记全部为已读
  markAllRead(): Promise<MarkAllReadResponse> {
    return http.post<MarkAllReadResponse>('/api/services/notifications/mark-all-read/')
  },

  // 软删除通知（后端ViewSet的删除通常为软删除）
  softDelete(id: number): Promise<{ success: boolean }> {
    return http.delete<{ success: boolean }>(`/api/services/notifications/${id}/`)
  },

  // 获取置顶的系统通知（可能为 null）
  getPinned(): Promise<NotificationItem | null> {
    return http.get<NotificationItem | null>('/api/services/notifications/pinned/')
  }
}

export default notificationsApi
